import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';
import { showTutorial } from '../tutorial.util';

export class Match2Tutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'match2';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'match2Started') {
      return false;
    }

    // Show tutorial popup and grant rewards
    await showTutorial('match2', {
      $stepIndex: 38,
      $stepName: 'match2',
    });

    return true;
  }
}
